class CollectionProductGrid extends HTMLElement {
  constructor() {
    super()

    const _this = this
    const loadMoreCTA = this.querySelector('.product-grid__load-more')
    const pageCount = loadMoreCTA?.getAttribute('data-page-count') || 0
    if (loadMoreCTA) {
      loadMoreCTA.addEventListener('click', function () {
        const currentPage = parseInt(loadMoreCTA.getAttribute('data-page'))
        const nextPage = currentPage + 1

        _this.loadProductsByPage(nextPage)
        _this.updateURL(nextPage)
      })
    }

    document.addEventListener('DOMContentLoaded', function () {
      const params = new URLSearchParams(window.location.search)
      const page = params.get('page')
      if (page) {
        const currentPage = parseInt(page, 10)

        for (let i = 1; i < currentPage; i++) {
          _this.loadProductsByPage(i, 'prepend')
        }

        if (pageCount == page) {
          loadMoreCTA.style.display = 'none'
        }
      }
    })
  }

  loadProductsByPage(page, mode = 'append') {
    const loadMoreCTA = this.querySelector('.product-grid__load-more')
    const collectionHandle = loadMoreCTA.getAttribute('data-collection')
    const pageCount = loadMoreCTA.getAttribute('data-page-count')

    fetch(`/collections/${collectionHandle}?page=${page}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to load more products')
        }
        return response.text()
      })
      .then((html) => {
        var parser = new DOMParser()
        var doc = parser.parseFromString(html, 'text/html')
        var newProducts = doc.querySelectorAll('.product-grid__item')

        if (newProducts.length > 0) {
          newProducts.forEach(function (product) {
            document
              .getElementById('main-collection-product-grid')
              [mode](product)
          })
          loadMoreCTA.setAttribute('data-page', page)
        }

        if (page == pageCount) {
          loadMoreCTA.style.display = 'none'
        }
      })
  }

  updateURL(page) {
    const newUrl = new URL(window.location)
    newUrl.searchParams.set('page', page)
    window.history.pushState(null, '', newUrl)
  }
}

customElements.define('collection-product-grid', CollectionProductGrid)
